/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { PlanComputeUpdateRequest } from '../../../../types/su-plan/requests/PlanComputeUpdateRequest';

export type UpdatePlanComputeDialogValues = PlanComputeUpdateRequest;

export const formInitialValues: UpdatePlanComputeDialogValues = {
  name: '',
  isVisible: false,
  isDefault: false,
};

export const validationSchema = Yup.object({
  name: Yup.string().required('empty'),
  isVisible: Yup.boolean(),
  isDefault: Yup.boolean(),
});
